import { type ComponentInstanceId } from 'job-lib/types/Job'

import { type LookUpType } from './hooks/useGetComponentMetadata/types'

const queryKeys = {
  connectorComponentMetadata: 'connectorComponentMetadata',
  componentMetadata: 'componentMetadata',
  componentSummaries: 'componentSummaries',
  connectorComponentSummaries: 'connectorComponentSummaries',
  jobSummaries: 'jobSummaries',
  job: 'job',
  project: 'project',
  taskStatus: 'taskStatus',
  taskDetails: 'taskDetails',
  taskStatusUpdate: 'flow-update',
  parameterOptions: 'parameterOptions',
  branches: 'branches',
  getBranch: 'getBranch',
  getWorkingTreeBranch: 'getWorkingTreeBranch',
  describeMerge: 'getMerge',
  validateComponent: 'validateComponent',
  listEnv: 'listEnvironments',
  listSchemas: 'listSchemas',
  listSchemaTables: 'listSchemaTables',
  listSchemaViews: 'listSchemaViews',
  listProjects: 'listProjects',
  listProjectVariables: 'listProjectVariables',
  merge: 'merge',
  pull: 'pull',
  describePull: 'describePull',
  agentDetails: 'agentDetails'
} as const

export type ParameterOptionsQueryKey = [
  typeof queryKeys.parameterOptions,
  string,
  string,
  string,
  LookUpType | null,
  ComponentInstanceId | null,
  string | undefined,
  string,
  Record<string, unknown>
]

export { queryKeys }
